import { InjectionToken } from '@angular/core';

import { FormErrorsMap } from './form-error.model';
import { pluralizeUnit } from '@shared/utils';

export const DEFAULT_ERROR_MESSAGES: FormErrorsMap = {
  required: 'Tato položka je povinná',
  pattern: 'Zadaná hodnota má chybný formát',
  noWhitespace: 'Zadaná hodnota obsahuje pouze prázdné znaky',
  email: 'Chybný formát e-mailu',
  notInPast: 'Datum nesmí být v minulosti',
  min: ({ min }) => {
    return `Minimální hodnota ${min}`;
  },
  max: ({ max }) => {
    return `Maximální hodnota ${max}`;
  },
  minlength: ({ requiredLength }) => {
    let chars = 'znaky';
    if (requiredLength === 1) chars = 'znak';
    if (requiredLength === 0 || requiredLength >= 5) chars = 'znaků';

    return `Délka minimálně ${requiredLength} ${chars}`;
  },
  maxlength: ({ requiredLength }) => {
    let chars = 'znaky';
    if (requiredLength === 1) chars = 'znak';
    if (requiredLength === 0 || requiredLength >= 5) chars = 'znaků';

    return `Délka maximálně ${requiredLength} ${chars}`;
  },

  maxlengthHtmlSource: ({ requiredLength }) => {
    let chars = 'znaky';
    if (requiredLength === 1) chars = 'znak';
    if (requiredLength === 0 || requiredLength >= 5) chars = 'znaků';

    return `Délka html zdroje musí být maximálně ${requiredLength} ${chars}`;
  },

  minNonWhitespaceLength: ({ requiredLength }) => {
    let chars = 'znaky';
    if (requiredLength === 1) chars = 'znak';
    if (requiredLength === 0 || requiredLength >= 5) chars = 'znaků';
    return `Délka minimálně ${requiredLength} ${chars}`;
  },

  invalidUrl: 'Neplatný formát URL.',

  dateFromGreaterThanDateTo: `Datum 'od' musí být menší než datum 'do'`,
  atLeastOneDateRequired: `Zadejte alespoň jedno datum (od nebo do)`,
  icoInvalid: `Zadané IČO není platné`,
  dateRangeInvalid: `Rozsah datumů je neplatný. Vyplňte obě pole.`,
  dateRangeExceedsMaxRange: ({ maxRange, unit }) => {
    return `Rozsah datumů může být maximálně ${maxRange} ${pluralizeUnit(maxRange, unit)}.`;
  },

  fromBeforeMinDatepickerRange: ({ requiredMin, isMinToday }) => {
    const fm = (requiredMin as Date).toLocaleDateString('cs-CZ');
    if (isMinToday) {
      return `Datum 'od' nesmí být dříve než dnešek – ${fm}.`;
    } else {
      return `Datum 'od' nesmí být dříve než ${fm}.`;
    }
  },

  toAfterMaxDatepickerRange: ({ requiredMax, isMaxToday }) => {
    const fm = (requiredMax as Date).toLocaleDateString('cs-CZ');
    if (isMaxToday) {
      return `Datum 'do' nesmí být později než dnešek – ${fm}.`;
    } else {
      return `Datum 'do' nesmí být později než ${fm}.`;
    }
  },
};

export const FORM_ERROR_PROVIDER = new InjectionToken<FormErrorsMap>('FormErrorProvider');
